import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import { Close, VolumeUp } from '@mui/icons-material';
import { useVoice } from '../contexts/VoiceContext';

const VoiceAssistant = () => {
  const { isListening, transcript, interimTranscript } = useVoice();
  const theme = useTheme();

  if (!isListening) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(37, 99, 235, 0.95)',
        color: 'white',
        padding: 3,
        borderRadius: 3,
        zIndex: 2000,
        textAlign: 'center',
        minWidth: 300,
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(10px)'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
        <VolumeUp sx={{ fontSize: 40, mr: 2, animation: 'pulse 1.5s infinite' }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Escuchando...
        </Typography>
      </Box>
      
      <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
        Habla en euskera o castellano
      </Typography>
      
      {(transcript || interimTranscript) && (
        <Box sx={{ mt: 2, p: 2, backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: 2 }}>
          <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
            "{transcript}{interimTranscript}"
          </Typography>
        </Box>
      )}
      
      <style jsx>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }
      `}</style>
    </Box>
  );
};

export default VoiceAssistant;
